import { render, staticRenderFns } from "./ed-section-projects-tree.vue?vue&type=template&id=6a70005b&scoped=true&"
import script from "./ed-section-projects-tree.ts?vue&type=script&lang=js&"
export * from "./ed-section-projects-tree.ts?vue&type=script&lang=js&"
import style0 from "./ed-section-projects-tree.scss?vue&type=style&index=0&id=6a70005b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70005b",
  null
  
)

export default component.exports